import _ from 'underscore';
import sha256 from 'js-sha256';

const generateIp = (): number[] => {
    const oct = [
      _.random(1, 254),
      _.random(1, 254),
      _.random(1, 254),
      _.random(1, 254)];
    const dec = (oct[0] + 16777216) + (oct[1] + 65536) + (oct[2] * 256) + oct[3];
    if (dec > 167772159 && dec < 184549376) {
      return generateIp();
    } else if (dec > 3232235519 && dec < 3232301056) {
      return generateIp();
    } else if (dec > 2886729727 && dec < 2887778304) {
      return generateIp();
    } else {
      return oct;
    }
  };

export const RandomIP = (): string => {
    return generateIp().join('.');
};

export const Hash = (item: string, len: number): string => {
    const val = sha256.sha256(item);
    if (len) {
        if (len < val.length) {
           return val.substr(0, len);
        }
    }
    return val;
};

export const BreakCamel = (str: string): string => {
  str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
  str = str.toLowerCase();
  return str;
};

export const IsNumber = (value: unknown): boolean => {
  return !isNaN(Number(value))
};

export const GetValue = (el: Element, str: string): string => {
  let val;
  if (el) {
    if (el.hasAttribute(str)) {
      val = el.getAttribute(str);
    }
  }
  if (val === null) {
    return '';
  } else if (val === undefined) {
    return '';
  } else {
    return val;
  }
};

export const TransformBoolean = (t: boolean | string | undefined): string => {
  if (t) {
    if (t.toString().toLowerCase() === 'true') {
      return 'Yes';
    }
  }
  return 'No';
};

export const DefaultValue = (s: string | number | null, str: string): string => {
  if (s) {
      if (!IsNumber(s.toString())) {
        if ((s as string).length > 0) {
          return (s as string);
        }
      } else {
        return s.toString();
      }
  }
  return str;
};

export const CheckNullFields = (n: NodeList): boolean => {
  for (const v of n.values()) {
    if (v === null || v === undefined) {
      return false;
    }
  }
  return true;
};

export const SplitBy = (t: string, c: string): string[] => {
  if (t.indexOf(c) > 0) {
    return t.split(c);
  } else {
    return [ t ];
  }
};

export const GetURI = (): string => {
  if (document.location.port !== '8080') {
    return `${document.location.origin}`;
  }
  return 'http://localhost';
};

export const TitleCase = (s: string): string => {
  if (s.indexOf(' ') > 0) {
    const se = s.split(' ');
    for (let i = 0; i < se.length; i++) {
      se[i] = se[i][0].toUpperCase() + se[i].slice(1);
    }
    return se.join(' ');
  } else {
    return `${s[0].toUpperCase()}${s.substring(1)}`;
  }
};

export const getBrowserLocale = (): string => {
  const navLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;
  if (!navLocale) {
    return 'en';
  } else {
    return navLocale.trim().split(/-|_/)[0];
  }
};
